import { render } from "./GiftDetail.vue?vue&type=template&id=35b353c9&scoped=true"
import script from "./GiftDetail.vue?vue&type=script&lang=js"
export * from "./GiftDetail.vue?vue&type=script&lang=js"

import "./GiftDetail.vue?vue&type=style&index=0&id=35b353c9&scoped=scoped&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35b353c9"]])

export default __exports__